// AUTO-GENERATED from /app/docs/legal/03_AVISO_LGPD.md. Do not edit by hand.
export default `# Aviso LGPD — BlueGov

O **BlueGov** trata dados pessoais de servidores e gestores públicos exclusivamente para viabilizar o cumprimento de Atos de Controle emitidos por órgãos fiscalizadores (TCE, TCU, CGU, MP) e o controle interno do Órgão Contratante.

## Finalidades
- Gestão de Atos de Controle, planos de ação e evidências.
- Cálculo do Índice de Proteção Institucional (IPI) e da Inteligência de Risco.
- Geração e verificação pública do Dossiê Executivo.
- Trilha de auditoria com Hash Chain SHA-256.
- Comunicação institucional de prazos e atribuições.

## Conformidade
- Tratamento conforme **Lei 13.709/2018 (LGPD)**, em especial os fundamentos do art. 7º, II, V, VI e IX.
- Multi-tenant com isolamento por órgão.
- Audit logs imutáveis e verificáveis.
- Sem envio de dados a terceiros para fins de marketing.
- Não utilizamos cookies de rastreamento, Google Analytics, Meta Pixel, Hotjar, Clarity ou similares.

## Encarregado (DPO)
**E-mail:** dpo@bluegov.com.br

Para conhecer os detalhes completos do tratamento, consulte a Política de Privacidade.
`;
